<template>
  <transition name="fade-down">
    <div v-if="data.time" class="notification" :class="['notification--' + data.theme]" @click="reset">
      <div class="notification__content">{{ data.content }}</div>
      <div class="notification__bar"></div>
    </div>
  </transition>
</template>

<script>
import Bus from '@/bus'

export default {
  watch: {
    'data.time': {
      handler: 'start',
      immediate: true,
    },
    '$route.query.notification': {
      handler(content) {
        if (!content) return
        this.set({ content })
        this.$router.replace({ query: { ...this.$route.query, notification: undefined } })
      },
      immediate: true,
    },
  },
  data() {
    return {
      data: {
        theme: 'default',
        content: null,
        time: null,
      },
    }
  },
  methods: {
    set({ theme = 'default', content, time = 6000 }) {
      this.data.theme = theme
      this.data.content = content
      this.data.time = time
    },
    start() {
      if (!this.data.time) return
      setTimeout(() => this.reset(), this.data.time)
    },
    reset() {
      this.data.theme = 'default'
      this.data.content = null
      this.data.time = null
    },
  },
  mounted() {
    Bus.$on('notification', data => this.set(data))
  },
}
</script>

<style lang="scss">
.notification {
  position: fixed;
  display: flex;
  z-index: get-layer('dropdown') + 1;
  top: 2rem;
  right: 3rem;
  max-width: 300px;

  box-shadow: var(--shadow-lg);
  border-radius: var(--border-radius-md);
  overflow: hidden;

  &__bar {
    width: 0.5rem;
    align-self: stretch;
    flex-shrink: 0;
  }

  &__content {
    padding: 1rem 2.5rem 1rem 1.5rem;
    font-weight: bold;
  }

  &--default {
    background-color: css-lightness('primary', 13%);
    color: white;

    .notification__bar {
      background-color: css-lightness('primary', 20%);
    }
  }
}
</style>
